"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var country_1 = tslib_1.__importDefault(require("./country"));
var StateResource = /** @class */ (function (_super) {
    tslib_1.__extends(StateResource, _super);
    function StateResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StateResource.endpoint = '/states';
    StateResource.MODEL_NAME = 'state';
    StateResource.related = {
        country: country_1.default,
    };
    return StateResource;
}(base_1.default));
exports.default = StateResource;
//# sourceMappingURL=state.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/state.js
// module id = PRWN
// module chunks = 0